// src/graphql/utils.js
// GraphQL utility functions

/**
 * Minify a GraphQL query by removing unnecessary whitespace while preserving string contents
 * @param {string} query - GraphQL query string
 * @returns {string} Minified query
 */
export const minifyQuery = (query) => {
    if (!query) return query;

    // Extract strings and replace with placeholders to protect their content
    const strings = [];
    const placeholder = '\0STRING\0';

    // Match both double-quoted and triple-quoted (block) strings
    const withPlaceholders = query.replace(
        /"""[\s\S]*?"""|"(?:[^"\\]|\\.)*"/g,
        (match) => {
            strings.push(match);
            return placeholder;
        }
    );

    // Minify the query (without strings)
    const minified = withPlaceholders
        .replace(/\s+/g, ' ')                    // Collapse whitespace to single space
        .replace(/\s*([{}(),:!@$])\s*/g, '$1')   // Remove space around punctuation
        .replace(/\s*\.\.\.\s*/g, '...')         // Handle spread operator
        .trim();

    // Restore strings
    let result = minified;
    for (const str of strings) {
        result = result.replace(placeholder, str);
    }

    return result;
};
